import { actionCreator } from 'utils';
import * as QuoteTypes from '../types/quoteTypes';

// L O A D   Q U O T E
export function loadQuote(id) {
    return {
        type: QuoteTypes.LOAD_QUOTE,
        id,
    };
}

export function loadQuoteRes(data) {
    return {
        type: actionCreator(QuoteTypes.LOAD_QUOTE, 'res'),
        data,
    };
}

export function loadQuoteErr() {
    return {
        type: actionCreator(QuoteTypes.LOAD_QUOTE, 'err'),
    };
}

export function setQuoteNeededData(data) {
    return {
        type: QuoteTypes.SET_QUOTE_NEEDED_DATA,
        data,
    };
}
// L O A D   Q U O T E


// A D D   N E W   Q U O T E
export function addNewQuote(data) {
    return {
        type: QuoteTypes.ADD_NEW_QUOTE,
        data,
    };
}
export function addNewQuoteRes(data) {
    return {
        type: actionCreator(QuoteTypes.ADD_NEW_QUOTE, 'res'),
        data,
    };
}

export function addNewQuoteErr() {
    return {
        type: actionCreator(QuoteTypes.ADD_NEW_QUOTE, 'err'),
    };
}
// A D D   N E W   Q U O T E

// E D I T   Q U O T E
export function editQuote(data, quoteReference) {
    return {
        type: QuoteTypes.EDIT_QUOTE,
        data,
        quoteReference,
    };
}
export function editQuoteRes(loading, success) {
    return {
        type: actionCreator(QuoteTypes.EDIT_QUOTE, 'res'),
        loading,
        success,
    };
}

export function editQuoteErr(error) {
    return {
        type: actionCreator(QuoteTypes.EDIT_QUOTE, 'err'),
        error,
    };
}
// E D I T   Q U O T E

// C A N C E L   Q U O T E
export function cancelQuote(quoteId, quoteReference) {
    return {
        type: QuoteTypes.CANCEL_QUOTE,
        quoteId,
        quoteReference,
    };
}
export function cancelQuoteRes(loading, success) {
    return {
        type: actionCreator(QuoteTypes.CANCEL_QUOTE, 'res'),
        loading,
        success,
    };
}

export function cancelQuoteErr(error) {
    return {
        type: actionCreator(QuoteTypes.CANCEL_QUOTE, 'err'),
        error,
    };
}
// C A N C E L   Q U O T E

// C L O N E   Q U O T E
export function cloneQuote(data, customerId, clonedQuoteId) {
    return {
        type: QuoteTypes.CLONE_QUOTE,
        data,
        customerId,
        clonedQuoteId,
    };
}
export function cloneQuoteRes(payload) {
    return {
        type: actionCreator(QuoteTypes.CLONE_QUOTE, 'res'),
        payload,
    };
}

export function cloneQuoteErr(error) {
    return {
        type: actionCreator(QuoteTypes.CLONE_QUOTE, 'err'),
        error,
    };
}
// C L O N E   Q U O T E

// C H A N G E   Q U O T E   S T A T U S
export function changeQuoteStatus(quoteId, quoteReference, quoteStatus) {
    return {
        type: QuoteTypes.CHANGE_QUOTE_STATUS,
        quoteId,
        quoteReference,
        quoteStatus,
    };
}
export function changeQuoteStatusRes(loading, success) {
    return {
        type: actionCreator(QuoteTypes.CHANGE_QUOTE_STATUS, 'res'),
        loading,
        success,
    };
}

export function changeQuoteStatusErr(error) {
    return {
        type: actionCreator(QuoteTypes.CHANGE_QUOTE_STATUS, 'err'),
        error,
    };
}
// C H A N G E   Q U O T E   S T A T U S


// A D D   N E W   Q U O T E   I T E M
export function addNewQuoteItem(data, view) {
    return {
        type: QuoteTypes.ADD_NEW_QUOTE_ITEM,
        data,
        view,
    };
}
export function addNewQuoteItemRes(loading, success) {
    return {
        type: actionCreator(QuoteTypes.ADD_NEW_QUOTE_ITEM, 'res'),
        loading,
        success,
    };
}

export function addNewQuoteItemErr() {
    return {
        type: actionCreator(QuoteTypes.ADD_NEW_QUOTE_ITEM, 'err'),
    };
}
// A D D   N E W   Q U O T E   I T E M

// L O A D   Q U O T E S   C O N T A C T
export function loadQuotesContact(customerId) {
    return {
        type: QuoteTypes.LOAD_QUOTES_CONTACT,
        customerId,
    };
}

export function loadQuotesContactRes(data) {
    return {
        type: actionCreator(QuoteTypes.LOAD_QUOTES_CONTACT, 'res'),
        data,
    };
}

export function loadQuotesContactErr() {
    return {
        type: actionCreator(QuoteTypes.LOAD_QUOTES_CONTACT, 'err'),
    };
}
// L O A D   Q U O T E S   C O N T A C T

// L O A D   Q U O T E S   S E N D E R
export function loadQuotesSender(customerId) {
    return {
        type: QuoteTypes.LOAD_QUOTES_SENDER,
        customerId,
    };
}

export function loadQuotesSenderRes(data) {
    return {
        type: actionCreator(QuoteTypes.LOAD_QUOTES_SENDER, 'res'),
        data,
    };
}

export function loadQuotesSenderErr() {
    return {
        type: actionCreator(QuoteTypes.LOAD_QUOTES_SENDER, 'err'),
    };
}
// L O A D   Q U O T E S   S E N D E R

// C L O N E   Q U O T E   I T E M
export function cloneQuoteItem(data, addresses, quoteId, clonedItemId) {
    return {
        type: QuoteTypes.CLONE_QUOTE_ITEM,
        data,
        addresses,
        quoteId,
        clonedItemId,
    };
}
export function cloneQuoteItemRes(payload) {
    return {
        type: actionCreator(QuoteTypes.CLONE_QUOTE_ITEM, 'res'),
        payload,
    };
}

export function cloneQuoteItemErr(error) {
    return {
        type: actionCreator(QuoteTypes.CLONE_QUOTE_ITEM, 'err'),
        error,
    };
}
// C L O N E   Q U O T E   I T E M

// D E L E T E   Q U O T E   I T E M
export function deleteQuoteItem(quoteItemId, quoteReference) {
    return {
        type: QuoteTypes.DELETE_QUOTE_ITEM,
        quoteItemId,
        quoteReference,
    };
}
export function deleteQuoteItemRes(payload) {
    return {
        type: actionCreator(QuoteTypes.DELETE_QUOTE_ITEM, 'res'),
        payload,
    };
}

export function deleteQuoteItemErr(error) {
    return {
        type: actionCreator(QuoteTypes.DELETE_QUOTE_ITEM, 'err'),
        error,
    };
}
// D E L E T E   Q U O T E   I T E M

// E D I T   Q U O T E   I T E M
export function editQuoteItem(data) {
    return {
        type: QuoteTypes.EDIT_QUOTE_ITEM,
        data,
    };
}

export function editQuoteItemRes(loading, success) {
    return {
        type: actionCreator(QuoteTypes.EDIT_QUOTE_ITEM, 'res'),
        loading,
        success,
    };
}

export function editQuoteItemErr() {
    return {
        type: actionCreator(QuoteTypes.EDIT_QUOTE_ITEM, 'err'),
    };
}
// E D I T   Q U O T E   I T E M

//  A D D   N E W   F A V O R I S   Q U O T E
export function addNewFavorisQuote(data) {
    return {
        type: QuoteTypes.ADD_NEW_FAVORIS_QUOTE,
        data,
    };
}
export function addNewFavorisQuoteRes(loading, success) {
    return {
        type: actionCreator(QuoteTypes.ADD_NEW_FAVORIS_QUOTE, 'res'),
        loading,
        success,
    };
}

export function addNewFavorisQuoteErr() {
    return {
        type: actionCreator(QuoteTypes.ADD_NEW_FAVORIS_QUOTE, 'err'),
    };
}
//  A D D   N E W   F A V O R I S   Q U O T E

//  D E L E T E   F A V O R I S   Q U O T E
export function deleteFavorisQuote(data) {
    return {
        type: QuoteTypes.DELETE_FAVORIS_QUOTE,
        data,
    };
}
export function deleteFavorisQuoteRes(loading, success) {
    return {
        type: actionCreator(QuoteTypes.DELETE_FAVORIS_QUOTE, 'res'),
        loading,
        success,
    };
}

export function deleteFavorisQuoteErr() {
    return {
        type: actionCreator(QuoteTypes.DELETE_FAVORIS_QUOTE, 'err'),
    };
}
//  D E L E T E   F A V O R I S   Q U O T E


// A D D   N E W   A D D I T I O N A L   I T E M
export function addQuoteAdditionalItem(data) {
    return {
        type: QuoteTypes.ADD_QUOTE_ADDITIONAL_ITEM,
        data,
    };
}
export function addQuoteAdditionalItemRes(loading, success) {
    return {
        type: actionCreator(QuoteTypes.ADD_QUOTE_ADDITIONAL_ITEM, 'res'),
        loading,
        success,
    };
}

export function addQuoteAdditionalItemErr() {
    return {
        type: actionCreator(QuoteTypes.ADD_QUOTE_ADDITIONAL_ITEM, 'err'),
    };
}
// A D D   N E W   A D D I T I O N A L   I T E M

// D E L E T E  A D D I T I O N A L   I T E M
export function deleteQuoteAdditionalItem(data) {
    return {
        type: QuoteTypes.DELETE_QUOTE_ADDITIONAL_ITEM,
        data,
    };
}

export function deleteQuoteAdditionalItemRes() {
    return {
        type: actionCreator(QuoteTypes.DELETE_QUOTE_ADDITIONAL_ITEM, 'res'),
    };
}

export function deleteQuoteAdditionalItemErr() {
    return {
        type: actionCreator(QuoteTypes.DELETE_QUOTE_ADDITIONAL_ITEM, 'err'),
    };
}
// D E L E T E   A D D I T I O N A L   I T E M
